///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../collections/report-manufacturers.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class InventoryProductCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected productCategories: InventoryProductCategoriesCollection;

        public totalSelectedMessage: string;
        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.productCategories;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.productCategories = new InventoryProductCategoriesCollection(this.model[this.properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.title = 'LABEL_PRODUCT_CATEGORY';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCT_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED';
        }
    }
}
